import i18n from '@/core/i18n';

/** Tooltip total in minutes, or `null` to hide the line (unknown or zero, like other optional rows) */
export function getAssignmentTotalBookedMinutes(
  bookedMinutes: number | null | undefined
): number | null {
  if (bookedMinutes === null || bookedMinutes === undefined || bookedMinutes <= 0) return null;

  return bookedMinutes;
}

/** `"48h"`, `"13h 43m"`, `"5,433h 15m"` — from whole minutes, so rounding can never give `"5h 60m"` */
export function formatTotalBookedHours(bookedMinutes: number): string {
  const totalMinutes = Math.round(bookedMinutes);
  const hours = new Intl.NumberFormat(i18n.language).format(Math.floor(totalMinutes / 60));
  const minutes = totalMinutes % 60;

  if (minutes === 0) return i18n.t('common:timeFormat.hoursOnly', { hours });

  return i18n.t('common:timeFormat.hoursAndMinutes', { hours, minutes });
}
